import {
	UPDATE_CANCEL_START,
	UPDATE_CANCEL_SUCCESS,
	UPDATE_CANCEL_ERROR
} from '../../../constants';
import history from '../../../core/history';
import { getCancellationPolicy, updateCancelPolicy as mutation, updateCancellationInfo } from '../../../lib/graphql';
import { setLoaderStart, setLoaderComplete } from '../../../actions/loader/loader'
import showToaster from '../../../helpers/toasterMessages/showToaster';

export  function updateCancelPolicy(values) {

	return async (dispatch, getState, { client }) => {

		try {
			let accommodationPriorCheckIn, accommodationBeforeCheckIn, accommodationDuringCheckIn, guestFeePriorCheckIn;
			let guestFeeBeforeCheckIn, guestFeeDuringCheckIn, hostFeePriorCheckIn, hostFeeBeforeCheckIn, hostFeeDuringCheckIn;
			let priorDays;
			const dynamicCancellationPolicyContent = values?.dynamicCancellationPolicyContent?.length > 0 ? JSON.stringify(values?.dynamicCancellationPolicyContent) : JSON.stringify([]);
			accommodationPriorCheckIn = parseFloat(values?.accommodationPriorCheckIn);
			accommodationBeforeCheckIn = parseFloat(values?.accommodationBeforeCheckIn);
			accommodationDuringCheckIn = parseFloat(values?.accommodationDuringCheckIn);
			guestFeePriorCheckIn = parseFloat(values?.guestFeePriorCheckIn);
			guestFeeBeforeCheckIn = parseFloat(values?.guestFeeBeforeCheckIn);
			guestFeeDuringCheckIn = parseFloat(values?.guestFeeDuringCheckIn);
			hostFeePriorCheckIn = parseFloat(values?.hostFeePriorCheckIn);
			hostFeeBeforeCheckIn = parseFloat(values?.hostFeeBeforeCheckIn);
			hostFeeDuringCheckIn = parseFloat(values?.hostFeeDuringCheckIn);
			priorDays = Number(values.priorDays);

			let variables = Object.assign({}, values, {
				accommodationPriorCheckIn, accommodationBeforeCheckIn, accommodationDuringCheckIn, guestFeePriorCheckIn,
				guestFeeBeforeCheckIn, guestFeeDuringCheckIn, hostFeePriorCheckIn, hostFeeBeforeCheckIn, hostFeeDuringCheckIn,
				priorDays, dynamicCancellationPolicyContent
			});

			dispatch({ type: UPDATE_CANCEL_START });
			dispatch(setLoaderStart("updateCancelPolicyLoading"));

			const { data } = await client.mutate({
				mutation,
				variables,
				refetchQueries: [{ query: getCancellationPolicy, variables: { id: values?.id } }]
			});

			const result = data?.updateCancelPolicy?.status

			dispatch({
				type: result === 200 ? UPDATE_CANCEL_SUCCESS : UPDATE_CANCEL_ERROR
			})

			showToaster({
				messageId: result === 200 ? 'updatePolicy' : 'commonError',
				toasterType: result === 200 ? 'success' : 'error',
				requestContent: result === 200 ? null : data?.updateCancelPolicy?.errorMessage

			})
			dispatch(setLoaderComplete("updateCancelPolicyLoading"));
			history.push('/siteadmin/cancellation-policies');

		} catch (error) {
			showToaster({ messageId: 'updateFailed', toasterType: 'error' })
			dispatch(setLoaderComplete("updateCancelPolicyLoading"));
			return false;
		}
		return true;
	};
}

export function updateCancellationPolicyInfoContent(values) {
	return async (dispatch, getState, { client }) => {
		try {
			dispatch(setLoaderStart("updateCancelPolicyLoading"));
			const variables = {
				id: values.id,
				description: values.dynamicCancellationInfo?.[0]?.description,
				dynamicCancellationInfo: JSON.stringify(values.dynamicCancellationInfo)
			};
			const { data } = await client.mutate({
				mutation: updateCancellationInfo,
				variables
			})

			if (data && data.updateCancellationInfo && data.updateCancellationInfo.status === 200) {
				dispatch(setLoaderComplete("updateCancelPolicyLoading"));
				showToaster({ messageId: 'cancelInfo', toasterType: 'success' })
				history.push('/siteadmin/cancellation-policies');

			} else {
				dispatch(setLoaderComplete("updateCancelPolicyLoading"));
				showToaster({ messageId: 'cancelInfoError', toasterType: 'error' })
			}

		} catch (error) {
			showToaster({ messageId: 'updateFailed', toasterType: 'error' })
			dispatch(setLoaderComplete("updateCancelPolicyLoading"));
			return false;
		}
		return true;
	}
}

